'use strict'

toCamelCase = (s) ->
  throw new Error 'String not defined' if not s
  Word = (w) -> w.charAt().toUpperCase() + w.slice 1
  s.split(/[-\s_.,&]+/g).map(Word).join ''

module.exports = {
  toCamelCase
}
